import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ExecutiveSummaryGuard implements CanActivate {
  constructor(private readonly router: Router) {
  }
  canActivate(
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const newBasePath = '/executive-insights';
    const newRoute = [newBasePath];

    const segments = state.url.split('/');

    segments
      .filter(segment => segment !== 'market-summary' && segment !== '')
      .forEach(segment => newRoute.push(segment));
    return this.router.createUrlTree(newRoute, {
      queryParams: route.queryParams,
      fragment: route.fragment
    });
  }
}